import { Chip, Box, CircularProgress } from "@mui/material";
import { useOrderInvoice } from "../../../api/moloni/useOrderInvoice";

type InvoiceChipsProps = {
    orderId: number | string;
};

export const InvoiceChips = ({ orderId }: InvoiceChipsProps) => {
    const { data: invoiceData, isLoading } = useOrderInvoice(orderId);

    if (isLoading) return <CircularProgress size={16} />;
    if (!invoiceData || invoiceData.length === 0) return null;

    return (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            {invoiceData.map((invoice: any) => (
                <Chip
                    key={invoice.document_id}
                    label={`${invoice.document_set_name} ${invoice.number}`}
                    size="small"
                    variant="outlined"
                />
            ))}
        </Box>
    );
};

